import React from "react";

function QuizShow() {
  return <div>QuizShow</div>;
}

export default QuizShow;
